import { Text, type TextProps, Tooltip } from '@mantine/core';
import dayjs from 'dayjs';
import type { TChangeStamp } from '@/models/invoicingCompanies';

const STALE_AFTER_MONTHS = 12;

/** Creation wrote the value; an update moved it. The two read differently. */
const VERB: Record<TChangeStamp['operation'], string> = {
  created: 'set',
  updated: 'changed',
};

const ROW_VERB: Record<TChangeStamp['operation'], string> = {
  created: 'added',
  updated: 'changed',
};

/**
 * When one field or row was last written. Renders nothing where nothing was
 * recorded: no date is better than a date the platform cannot stand behind.
 */
export default function ChangeStamp({
  stamp,
  variant = 'field',
  ...textProps
}: {
  stamp: TChangeStamp | null | undefined;
  variant?: 'field' | 'row';
} & TextProps) {
  if (!stamp) return null;

  const at = dayjs(stamp.at);
  const stale = dayjs().diff(at, 'month') >= STALE_AFTER_MONTHS;
  const verb = variant === 'row' ? ROW_VERB : VERB;

  return (
    <Tooltip
      label={`${at.format('DD.MM.YYYY HH:mm')}${
        stamp.actor ? ` - ${stamp.actor}` : ''
      }`}
    >
      <Text
        size="xs"
        c={stale ? 'orange.8' : 'dimmed'}
        component="span"
        {...textProps}
      >
        {verb[stamp.operation]} {at.fromNow()}
      </Text>
    </Tooltip>
  );
}
